import { isTenantOrFacilityAdmin } from "./permissionAccess";

/** Configuration and admin screens require tenant or facility admin role. */
export function canAccessConfiguration(roles: string[] | undefined): boolean {
  return isTenantOrFacilityAdmin(roles);
}
